
import { endpoints } from "../api"
import { setLoading } from "../../slices/AuthSlice";
import toast from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import {message} from '../../messages/Message'


const {CREATE_JOB_POST,GET_JOB_POST,GET_SKILLS,GET_INDSUTRY,WRITE_WITH_AT,GET_PASSIVE_CANDIDATES,GET_APPLICANTS,VIEW_RESUME_API,GENERATE_CAREER_LINK,GET_CAREER_PAGE_JOBS,GET_CAREER_PAGE_JOB_VIEW,CHANGE_STATUS,EMBED_JOB_APPLY}=endpoints;
const BASE_URL = process.env.REACT_APP_BASE_URL



export function getSKills(token) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const response = await apiConnector("GET", GET_SKILLS, "", { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 422) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function getIndustry(token) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const response = await apiConnector("GET", GET_INDSUTRY, "", { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 422) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function createJobPost(payload,token,onClose) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", CREATE_JOB_POST, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.data?.status === 201) {
        dispatch(setLoading(false));
        onClose();
        toast.success(response.data.message)
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 422) {
        onClose();
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        onClose();
        toast.error(error.response.data.message);
      }
    }
  }
}

export function getJobPost(token,params={}) {
  return async (dispatch) => {
 //dispatch(setLoading(true))
    try {
        const response = await apiConnector("GET", GET_JOB_POST, "", { 'Authorization': `Bearer ${token}` },params)
      if (response?.status === 200) {
       // dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
     // dispatch(setLoading(false));
      if (error?.response?.status === 422) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function viewJobPost(token,id) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const url=BASE_URL+`api/view-job-posting/${id}`
        const response = await apiConnector("GET", url, "", { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 422) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function editJobPost(payload,token,onClose,id) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const url=BASE_URL+`api/edit-job-posting/${id}`
        const response = await apiConnector("PUT", url, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
        onClose()
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
        toast.error(error.response.data.message)
        onClose()
      }
      
      if (error?.response?.status === 500) {
        onClose();
        toast.error(error.response.data.message);
       
      }
    }
  }
}

export function closeJobPost(payload,token,id) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const url=BASE_URL+`api/update-job-status/${id}`
        const response = await apiConnector("PUT", url, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function deleteJobPost(payload,token,id) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const url=BASE_URL+`api/update-job-status/${id}`
        const response = await apiConnector("PATCH", url, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function writeWithAi(payload,token) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", WRITE_WITH_AT, payload, { 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
        toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function getPassiveCandidates(payload,token) {
  return async (dispatch) => {
 //dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", GET_PASSIVE_CANDIDATES, payload,{ 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        //dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      //dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        return error.response;
      }
      if (error?.response?.status === 404) {
        return error.response;
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}



export function getApplicantListing(payload,token) {
  return async (dispatch) => {
 //dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", GET_APPLICANTS, payload,{ 'Authorization': `Bearer ${token}` })
      if (response?.status === 200) {
        //dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      //dispatch(setLoading(false));
      if (error?.response?.status === 403) {
        return error.response;
      }
      if (error?.response?.status === 404) {
        return error.response;
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function viewResume(token, payload) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", VIEW_RESUME_API, payload, { 'Authorization': `Bearer ${token}` })

      if (response?.status === 201 || response?.status === 200) {
        dispatch(setLoading(false))
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      // if (error?.response?.data?.status === 400) {
      //   toast.error(error.response.data.message);
      // }
      // if (error?.response?.data?.status === 404) {
      //   toast.error(error.response.data.message);
      // }
      // if (error.status === 500) {
      //   toast.error(message.errorMessage);
      // }
    }
  }
}



export function getCareerPageLink(token) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
        const response = await apiConnector("POST", GENERATE_CAREER_LINK, "",{ 'Authorization': `Bearer ${token}` })
      if (response?.status === 201) {
        dispatch(setLoading(false));
        toast.success(response.data.message);
        return response
      }
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message);
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
      toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
          toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}

export function getCareerPageJobs(payload,per_page,page) {
  return async (dispatch) => {
  dispatch(setLoading(true))
    try {
        const response = await apiConnector(
        "POST",
        `${GET_CAREER_PAGE_JOBS}?per_page=${per_page}&page=${page}`,
        payload
      );

      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
      toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
          toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function getCareerPageJobDetail(id) {
  return async (dispatch) => {
  dispatch(setLoading(true))
    try {
        const response = await apiConnector(
        "GET",
        `${GET_CAREER_PAGE_JOB_VIEW}/${id}`,""
      );

      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
      toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
          toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function  embedApplyJob(formData,onClose) {
  return async (dispatch) => {
  dispatch(setLoading(true))
  try{
     const response = await apiConnector("POST", EMBED_JOB_APPLY, formData,{
       "Content-Type": "multipart/form-data",
       })
       
      if (response?.status === 200) {
        dispatch(setLoading(false));
        onClose();
        toast.success(response.data.message)
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
      toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
          toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.message);
      }
    }
  }
}


export function  changeHiringStatus(payload,token) {
  return async (dispatch) => {
  dispatch(setLoading(true))
  try{
     const response = await apiConnector("POST", CHANGE_STATUS, payload,{ 'Authorization': `Bearer ${token}` })
     
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 403) {
      toast.error(error.response.data.message)
      }
      if (error?.response?.status === 404) {
          toast.error(error.response.data.message)
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.message);
      }
    }
  }
}






